import { render, staticRenderFns } from "./CoreActionMenu.vue?vue&type=template&id=8350b9cc&scoped=true&"
import script from "./CoreActionMenu.vue?vue&type=script&lang=ts&"
export * from "./CoreActionMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CoreActionMenu.vue?vue&type=style&index=0&id=8350b9cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8350b9cc",
  null
  
)

export default component.exports